let utils = require('../helpers/utils');
let errorConverter = require('../helpers/errorToObjectConverter');

/**
 * посылаем логи ошибки на WebAPI
 * @param args
 * @param state
 * @param locator
 * @param context
 * @constructor
 */
function sendErrorLogToWebApi (errorType, errorId, args, state, locator, context) {
    let error = args.error;
    let api = locator.resolve('api');
    let user = state.get(['user']);
    api.logOnWebApi(context, locator, {
        level: 'info',
        message: [ errorType, errorId, errorConverter.convert(error), user ]
    });
}

module.exports = {
    unauthorized (args, state, output, { context }) {
        context.redirect(utils.patchQueryWithUtm('/', state));
    },

    accessDenied (errorId) {
        return (args, state, output, { locator, context }) => {
            state.set(['layout'], 'error');
            state.set(['errorType'], 'accessDenied');
            state.set(['title'], 'Доступ запрещен');
            state.set(['description'], 'Доступ к этому разделу ограничен');
            sendErrorLogToWebApi('accessDenied', errorId, args, state, locator, context);
        };
    },

    internalError (errorId) {
        return (args, state, output, { locator, context }) => {
            state.set(['layout'], 'error');
            state.set(['errorType'], 'internalError');
            state.set(['title'], 'Что-то пошло не так, но мы уже чиним');
            state.set(['description'], 'Что-то пошло не так, но мы уже чиним.');
            sendErrorLogToWebApi('internalError', errorId, args, state, locator, context);
        };
    },

    notFound (errorId, isDontLog = false) {
        return (args, state, output, { locator, context }) => {
            state.set(['layout'], 'error');
            state.set(['errorType'], 'notFound');
            state.set(['title'], 'Нет такой страницы');
            state.set(['description'], 'Нет такой страницы. Быть может её и вовсе не существовало.');
            if (!isDontLog) {
                sendErrorLogToWebApi('notFound', errorId, args, state, locator, context);
            }
        };
    },

    passportError (errorId) {
        return (args, state, output, { locator, context }) => {
            state.set(['layout'], 'error');
            state.set(['errorType'], 'passportError');
            state.set(['title'], 'Что-то пошло не так, но мы уже чиним');
            state.set(['description'], 'Что-то пошло не так, но мы уже чиним.');
            sendErrorLogToWebApi('passportError', errorId, args, state, locator, context);
        };
    },

    bitrixUnavailableError (errorId) {
        return (args, state, output, { locator, context }) => {
            state.set(['layout'], 'error');
            state.set(['errorType'], 'unavailableError');
            state.set(['title'], 'Нет доступа к вашему Битрикс24');
            state.set(['description'], 'Нет доступа к вашему Битрикс24.');
            sendErrorLogToWebApi('bitrixUnavailableError', errorId, args, state, locator, context);
        };
    },

    bitrixCertificateError (errorId) {
        return (args, state, output, { locator, context }) => {
            state.set(['layout'], 'error');
            state.set(['errorType'], 'certificateError');
            state.set(['title'], 'Сертификат вашего Битрикс24 недействителен');
            state.set(['description'], 'Сертификат вашего Битрикс24 недействителен');
            sendErrorLogToWebApi('bitrixCertificateError', errorId, args, state, locator, context);
        };
    },

    cookieDisabled (errorId) {
        return (args, state, output, { locator, context }) => {
            state.set(['layout'], 'error');
            state.set(['errorType'], 'cookieDisabled');
            state.set(['title'], 'У вас в браузере выключены cookie, работа сайта невозможна');
            state.set(['description'], 'У вас в браузере выключены cookie, работа сайта невозможна');
            sendErrorLogToWebApi('cookieDisabled', errorId, args, state, locator, context);
        };
    }
};



// WEBPACK FOOTER //
// ./actions/error.js